export const getPriceCodeSettings = () => {
  try {
    const settings = localStorage.getItem('priceCodeSettings');
    return settings ? JSON.parse(settings) : { enabled: false, digitMap: {}, zeroLetters: ['', ''], repeatLetter: '', scope: 'everything' };
  } catch {
    return { enabled: false, digitMap: {}, zeroLetters: ['', ''], repeatLetter: '', scope: 'everything' };
  }
};

export const setPriceCodeSettings = (enabled, digitMap, zeroLetters, repeatLetter, scope) => {
  localStorage.setItem('priceCodeSettings', JSON.stringify({
    enabled,
    digitMap: digitMap || {},
    zeroLetters: zeroLetters || ['', ''],
    repeatLetter: repeatLetter || '',
    scope: scope || 'everything',
  }));
};

export const priceToCode = (price) => {
  const settings = getPriceCodeSettings();
  const { enabled, digitMap, zeroLetters, repeatLetter } = settings;

  if (!enabled || !digitMap || Object.keys(digitMap).length !== 9 || !zeroLetters || zeroLetters.length !== 2 || !zeroLetters[0] || !zeroLetters[1] || !repeatLetter) {
    return `LKR ${parseFloat(price).toFixed(2)}`;
  }

  const rounded = Math.round(parseFloat(price));
  const digits = String(rounded).split('');
  let zeroToggle = 0;
  let result = '';

  for (let i = 0; i < digits.length; i++) {
    const digit = digits[i];
    const prevDigit = i > 0 ? digits[i - 1] : null;

    if (digit === '0') {
      result += zeroLetters[zeroToggle % 2];
      zeroToggle++;
    } else if (digit === prevDigit) {
      result += repeatLetter;
    } else {
      result += digitMap[digit] || '?';
    }
  }

  return result;
};

export const isBarcodeOnly = () => {
  const settings = getPriceCodeSettings();
  return settings.enabled && settings.scope === 'barcode_only';
};

export const isCodeEnabled = () => {
  const settings = getPriceCodeSettings();
  return settings.enabled;
};

export const validateAllLetters = (digitMap, zeroLetters, repeatLetter) => {
  const allLetters = [
    ...Object.values(digitMap || {}),
    ...(zeroLetters || []),
    repeatLetter,
  ].filter(l => l);

  if (allLetters.length !== 12) return false;
  const uniqueLetters = new Set(allLetters.map(l => l.toUpperCase()));
  if (uniqueLetters.size !== 12) return false;
  return true;
};